import Box from "@mui/material/Box";

import { zinc } from "@/ui/tokens";
import { HighlightedText, SEARCH_MARK_SX, useSearchTermFor } from "./searchHighlight";

/**
 * A Dispatch cell's text on one line, cut with an ellipsis where the column ends; `muted` greys it. In a column the
 * search scans (`field`), the runs it matched are marked.
 */
export function TextCell({ value, muted, field }: { value: string; muted?: boolean; field?: string }) {
  const term = useSearchTermFor(field);
  return (
    <Box
      component="span"
      sx={{
        color: muted ? zinc[400] : undefined,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        ...SEARCH_MARK_SX,
      }}
    >
      <HighlightedText text={value} term={term} />
    </Box>
  );
}
